export const CDN_IMAGE_URL = "https://cdn.dotpe.in/cfe/image";
export const API_BASE_URL = "https://cdn.dotpe.in/cfe/image";
export const CDN_ORACLE_URL = "https://cdn.dotpe.in/oracle";
export const RISTA_API_URL = process.env.REACT_APP_RISTA_BASE_API_URL;
export const RISTA_CDN_URL = "https://static.apps.dev.ristasales.com/b";
// Both moved to @rista/core/config (identical literals in web and mobile) and re-exported so
// every importer of "config" is untouched. RISTA_API_URL stays here — it is
// process.env.REACT_APP_*, which webpack inlines at build time.
export { RISTA_CUSTOM_URL, RISTA_COMMON_URL } from "@rista/core/config";
export const RECOMMENDATION_ENGINE_URL = process.env.REACT_APP_RECOMMENDATION_ENGINE_URL;

//export const RISTA_API_URL = "http://localhost:8000/business/services/bn";
//export const RISTA_API_URL = "https://apps.dev.ristasales.com/business/services/bn/";
